import { useCallback } from 'react';
import { Button } from '@plone/components';
import Logo from '@ifpb/portal/components/Logo/Logo';
import Icon from '@plone/volto/components/theme/Icon/Icon';
import closeSVG from '@plone/volto/icons/circle-dismiss.svg';

const CloseMenu = ({ toggleNavMenu }) => {
  const closeMenu = useCallback(
    (e) => {
      e.stopPropagation();
      toggleNavMenu();
    },
    [toggleNavMenu],
  );

  return (
    <div className="close-wrapper">
      <div className="close">
        <Button onClick={closeMenu} className="closeButton">
          <Icon name={closeSVG} size="40px" />
        </Button>
      </div>
    </div>
  );
};

const NavigationHeader = ({ toggleNavMenu }) => {
  return (
    <div className="nav-block nav-header">
      <Logo isFooterLogo={false} />
      <CloseMenu toggleNavMenu={toggleNavMenu} />
    </div>
  );
};

export default NavigationHeader;
